<template>
  <div style="border-right: 1px solid #DBDBDB; margin: 26px 0 0 0;">
    <a-spin :spinning="spinning">
      <radial-bar-chart
        v-if="chartData.length"
        chart-id="overview-memory-usage-chart"
        :chart-data="chartData"
        legendPosition="right"
        :flip-page=false
        :style="{paddingTop: chartData.length ? '0px' : '40px', maxHeight: '240px', overflow: 'hidden'}"
      ></radial-bar-chart>
      <div v-else style="height: 240px; position: relative; overflow: hidden;">
        <empty-component
          :imgUrl="require('@/assets/images/info_empty.png')"
          :body-style="{
            height: '120px',
            marginTop: '28px'
          }"
          :description-style="{
            marginTop: '-8px',
            marginRight: '8px'
          }"
          description="暂无数据"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { getHypervisorHostTop } from '@/api/hypervisor'
import RadialBarChart from '@/components/chart/RadialBarChart'

export default {
  name: 'HostMemoryUsageTop',
  components: {
    EmptyComponent: () => import('@/components/EmptyComponent.vue'),
    RadialBarChart
  },
  props: {
    hypervisorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartData: [],
      spinning: false
    }
  },
  mounted () {
    this.spinning = true
    getHypervisorHostTop(this.hypervisorId, { top_of: 'memory', limit: 5 }).then(res => {
      this.chartData = res.data.data
    }).finally(() => { this.spinning = false })
  }
}
</script>
